export default {
  getMaintenances: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/maintenances/getters.js